<template>
  <div class="content-1">
    <h3>{{ transPeralbaPro.item808 }}</h3>
    <h4>{{ transPeralbaPro.item809 }} <strong>{{ email }}</strong>.</h4>
    <h4>{{ transPeralbaPro.item810 }} <a @click="goToForgetPassword">{{ transPeralbaPro.item811 }}</a></h4>
    <button
      type="button"
      :disabled="disabledForm"
      class="btn-per-dark-outlined mt-4"
      @click="volverInicioSesion"
    >{{ transPeralbaPro.item812 }}</button>
  </div>
</template>
<script>
import navigation from "../mixins/navigation";
export default {
  mixins: [navigation],
  props: ["email", "disabledForm", "transPeralbaPro"],
};
</script>
